<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">直播课管理&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" style="width: 140px">
            新增
          </button>
          <div class="searcharea">


            <input class="form-control" placeholder="名称"  v-model="searchParams.name"/>
            <button type="button" class="btn btn-default btn_option" @click="initDataList()">查询</button>
          </div>
        </div>
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage">
            <thead>
            <tr>
              <th width="35%">课程名称</th>
              <th width="25%">时间</th>
              <th >主讲教师</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, index) in dataList" :key="index">
              <td><a :href="d.liveUrl" target="_blank" referrerpolicy="no-referrer">{{d.name}} </a></td>
              <td>{{d.startDate}} {{d.startTime}}-{{d.endTime}}</td>
              <td>
                <div class="description-content">
                  {{d.teacherName}}
                </div>
              </td>
              <td>

                <div class="edit_pic" data-toggle="modal"
                     @click="edit(d)">
                </div>
                <div class="delete_pic" @click="deleteById(d.id)"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>
          <!--新增或修改-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    {{option_flag=="add"?'新增':'修改'}}
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label>课程名称：</label>
                    <input type="text" class="form-control" v-validate="'required|maxL:100'" data-vv-scope="scope" data-vv-as="课程名称" name="name" placeholder="输入名称" v-model="data.name">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.name') }}</span>

                    <label>培训日期：</label>
                    <input v-validate="'required|date_format:yyyy-MM-dd'" data-vv-scope="scope" data-vv-as="培训日期" class="form-control datetimepicker" size="16" type="text" placeholder="选择日期" name="startDate" id="startDate" readonly v-model="data.startDate" autocomplete="off"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.startDate') }}</span>

                    <label>培训时间：</label>
                    <input v-validate="'required'" data-vv-scope="scope" data-vv-as="培训时间" name="startTime" class="form-control" type="text" placeholder="输入培训时间" v-model="data.startTime" @click="showTimeDiv()" readonly autocomplete="off"><!-- @blur="hideTimeDiv()"-->
                    <div id="time_div">
                      <option v-for="(les_time,index) in lesson_time" :key="index" :value="les_time"
                              @click="putTimeData(index)">{{les_time}}</option>
                      <option value="" @click="putTimeData(-1)">自定义</option>
                    </div>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.startTime') }}</span>

                    <label>主讲教师：</label>
                    <input type="text" class="form-control" v-validate="'maxL:100'" data-vv-scope="scope" data-vv-as="主讲教师" name="teacherName" placeholder="输入主讲教师" v-model="data.teacherName" autocomplete="off">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.teacherName') }}</span>

                    <label>直播地址：</label>
                    <input type="text" class="form-control" v-validate="'required|maxL:200'" data-vv-scope="scope" data-vv-as="直播地址" name="liveUrl" placeholder="输入直播地址" v-model="data.liveUrl" autocomplete="off">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.liveUrl') }}</span>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 模态框（Modal） -->
          <div class="modal fade" id="myModal_time" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_time" aria-hidden="true">
            <div class="modal-dialog time_dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel_time">培训时间</h4>
                </div>
                <div class="modal-body">
                  <div style="margin: 10px 0">
                    <label>开始时间：</label>
                    <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="startTime" class="form-control" style="width: 78%" placeholder="开始时间" v-model="selfTime.startTime"/>
                    <span class="validateTip">{{ errors.first('selfTime.startTime') }}</span>
                  </div>
                  <div style="margin: 10px 0">
                    <label>结束时间：</label>
                    <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="endTime" class="form-control" style="width: 78%" placeholder="结束时间" v-model="selfTime.endTime"/>
                    <span class="validateTip">{{ errors.first('selfTime.endTime') }}</span>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn" @click="chooseTimeOk()">确定</button>
                  <button type="button" class="btn" data-dismiss="modal">返回</button>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import pageView from './pageView';
  import dictionaryData from '../json/dictionary';
  import {Validator} from 'vee-validate';

  export default {
    name: "trainingManage",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        resourcePath:  this.$store.state.serviceBase + "resources/",
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',
        //培训人员集合
        dataList:[],

        option_flag: 'add',

        //培训人员对象
        data:{
          id:'',
          name:'',
          lessonId:'',
          startDate:'',
          startTime:'',
          teacherName:'',
          liveUrl:''
        },
        selfTime:{
          startTime:"",
          endTime:""
        },
        searchParams: {
          name:'',
          all: 0,
          rows: 10,
          page:1
        },
        //上课时间数组
        lesson_time: dictionaryData.lesson_time,

      }
    },


    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initDataList();//日期
        this_.dateDefault();
        //绑定加载关闭模态框时的事件
        this_.closeModal();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDataList;
      });
    },
    methods: {

      initDataList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'lessonLive/findPage',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataList = resp.data.list;
            this_.searchParams.all = resp.data.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },


      saveData(){
        let this_ = this;
        this_.$validator.validateAll('scope').then(result => {
          if (result) {
            let method = "";
            let url = "";
            if (this_.option_flag == "add") {
              method = "post";
              url = "lessonLive/add";
            } else {
              method = "put";
              url = "lessonLive/edit";
            }
            schoolAxios({
              method: method,
              url: url,
              data: this_.data
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initDataList();
              } else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        });
      },

      edit(d){
        let this_ = this;
        this_.data = d;
        this_.data.startTime = this_.data.startTime+"-"+this_.data.endTime
        this_.option_flag = "edit"
        $("#myModal").modal("show");
      },


      /**
       * 删除培训人员
       */
      deleteById(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'lessonLive/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.data = {
            id:'',
              name:'',
              lessonId:'',
              startDate:'',
              startTime:'',
              teacherName:'',
              liveUrl:''
          },

          this_.option_flag= 'add';
          setTimeout(function () {
            this_.errors.clear('scope');
          });

        });

      },
      /**
       * 初始化日期选这框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('.datetimepicker').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let id = ev.delegateTarget.id;
          if(id == "startDate"){
            let value = $("#startDate").val();
            this_.data.startDate = value;
          }
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
      showTimeDiv(){
        $("#time_div").show();
      },
      hideTimeDiv(){
        $("#time_div").hide();
      },
      putTimeData(index){
        let this_ = this;
        if(index >= 0) {
          let data = this_.lesson_time[index];

          this_.data.startTime = data;
          $("#time_div").hide();
        }else {
          //this_.new_schedule.time = "";
          $("#time_div").hide();

          $("#myModal_time").modal("show");
        }
      },

      chooseTimeOk(){
        let this_ = this;
        this_.$validator.validateAll('selfTime').then(result => {
          if (result) {
            this_.data.startTime = this_.selfTime.startTime + "-" + this_.selfTime.endTime;
            $("#myModal_time").modal("hide");
          }
        });
      },

      chooseTimeBySelf(){
        let this_ = this;

        $("#myModal_time").modal("show");
      },

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .body_top {
    margin: 20px 0;
  }
  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }
  .table_trainingManage {
    margin: 20px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/edit_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 25px 0 25px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
    background-size: 100% 100%;
    float: left;
  }
  .modelInput{
    height: 34px;
    width: 90%;
    margin-top: 2%;
    margin-left: 5%;
  }

  #time_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  #time_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #time_div option:hover {
    background-color: grey;
  }
  .modal-body .form-control{
    display: inline-block;
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/lessonLive.vue